var chunkMapping = {
	"171": [
		30171
	],
	"245": [
		60245
	],
	"273": [
		40273
	],
	"508": [
		30508
	],
	"548": [
		90548
	],
	"577": [
		10577
	],
	"682": [
		682
	],
	"745": [
		70745
	],
	"778": [
		50778
	],
	"780": [
		20780
	],
	"862": [
		10862
	],
	"947": [
		20947
	],
	"990": [
		20990
	],
	"1041": [
		11041
	],
	"1151": [
		11151
	],
	"1262": [
		6023
	],
	"1420": [
		51420
	],
	"1543": [
		31543
	],
	"1567": [
		91567
	],
	"1932": [
		51932
	],
	"1967": [
		61967
	],
	"2311": [
		62311
	],
	"2325": [
		32325
	],
	"2352": [
		82352
	],
	"2466": [
		2466
	],
	"2477": [
		2477
	],
	"2594": [
		22594
	],
	"2637": [
		32637
	],
	"2929": [
		82929
	],
	"3404": [
		33404
	],
	"3523": [
		93523
	],
	"3534": [
		3534
	],
	"3570": [
		24590
	],
	"3590": [
		3590
	],
	"3723": [
		23723
	],
	"3742": [
		73742
	],
	"3966": [
		53966
	],
	"3973": [
		13973
	],
	"3981": [
		33981
	],
	"3993": [
		23993
	],
	"4123": [
		14123
	],
	"4136": [
		4136
	],
	"4228": [
		34228
	],
	"4327": [
		24327
	],
	"4341": [
		44341
	],
	"4536": [
		14536
	],
	"4803": [
		14803
	],
	"4866": [
		4866
	],
	"4930": [
		54930
	],
	"4946": [
		62290
	],
	"4969": [
		4969
	],
	"5379": [
		85379
	],
	"5688": [
		5688
	],
	"5752": [
		45752
	],
	"5846": [
		15846
	],
	"5918": [
		63973
	],
	"5955": [
		5955
	],
	"5960": [
		35960
	],
	"6688": [
		26688
	],
	"7086": [
		17086
	],
	"7097": [
		67097
	],
	"7217": [
		87217
	],
	"7400": [
		27400
	],
	"7471": [
		47471
	],
	"7578": [
		27578
	],
	"7674": [
		37674
	],
	"7704": [
		97704
	],
	"7788": [
		57788
	],
	"8016": [
		78016
	],
	"8024": [
		68024
	],
	"8047": [
		98047
	],
	"8089": [
		8089
	],
	"8095": [
		28095
	],
	"8234": [
		38234
	],
	"8338": [
		58338
	],
	"8382": [
		58382
	],
	"8418": [
		88418
	],
	"8527": [
		68527
	],
	"8546": [
		88546
	],
	"8641": [
		48641
	],
	"8676": [
		18676
	],
	"8783": [
		98783
	],
	"9194": [
		19194
	],
	"9569": [
		29569
	],
	"9661": [
		49661
	],
	"9669": [
		19669
	],
	"9786": [
		9786
	],
	"9802": [
		29802
	]
};
var idToExternalAndNameMapping = {
	"682": [
		"default",
		"./update-profile-page",
		43313
	],
	"2466": [
		"default",
		"./manual-order-page",
		59888
	],
	"2477": [
		"default",
		"./supplier-inventory-setting-page",
		13445
	],
	"3534": [
		"default",
		"./pos-settings-page",
		86285
	],
	"3590": [
		"default",
		"./hcp-order-view-page",
		59888
	],
	"4136": [
		"default",
		"./quotation-view",
		59888
	],
	"4866": [
		"default",
		"./category-create-page",
		86285
	],
	"4969": [
		"default",
		"./ms/translation",
		59888
	],
	"5688": [
		"default",
		"./report-view-page",
		90706
	],
	"5955": [
		"default",
		"./sales-page",
		22084
	],
	"6023": [
		"default",
		"./en/translation",
		90706
	],
	"8089": [
		"default",
		"./customer-quotation-request-view",
		59888
	],
	"9786": [
		"default",
		"./customer-create-page",
		43313
	],
	"10577": [
		"default",
		"./generic-name-listing-page",
		86285
	],
	"10862": [
		"default",
		"./ms/translation",
		86143
	],
	"11041": [
		"default",
		"./admin-view-page",
		90706
	],
	"11151": [
		"default",
		"./chat-conversation-page",
		59888
	],
	"13973": [
		"default",
		"./ms/translation",
		90706
	],
	"14123": [
		"default",
		"./machine-setup-page",
		86285
	],
	"14536": [
		"default",
		"./manual-order-create-edit-page",
		59888
	],
	"14803": [
		"default",
		"./quotation-listing",
		59888
	],
	"15846": [
		"default",
		"./en/translation",
		86285
	],
	"17086": [
		"default",
		"./customer-listing-page",
		43313
	],
	"18676": [
		"default",
		"./en/translation",
		43313
	],
	"19194": [
		"default",
		"./ms/translation",
		86285
	],
	"19669": [
		"default",
		"./supplier-warehouse-view-page",
		13445
	],
	"20780": [
		"default",
		"./moh-create-order-page",
		59888
	],
	"20947": [
		"default",
		"./ms/translation",
		22084
	],
	"20990": [
		"default",
		"./pos-order-listing-page",
		59888
	],
	"22594": [
		"default",
		"./supplier-stock-transfer-form-page",
		13445
	],
	"23723": [
		"default",
		"./hcp-dispatch-view-page",
		59888
	],
	"23993": [
		"default",
		"./media-upload-page",
		86285
	],
	"24327": [
		"default",
		"./en/translation",
		68741
	],
	"24590": [
		"default",
		"./services",
		86143
	],
	"26688": [
		"default",
		"./platform-settings-page",
		86285
	],
	"27400": [
		"default",
		"./voucher-view-page",
		86285
	],
	"27578": [
		"default",
		"./supplier-inventory-update-page",
		13445
	],
	"28095": [
		"default",
		"./supplier-stock-transfer-page",
		13445
	],
	"29569": [
		"default",
		"./manufacturer-listing-page",
		86285
	],
	"29802": [
		"default",
		"./ongoing-pos-sessions-page",
		22084
	],
	"30171": [
		"default",
		"./customisation-create-page",
		86285
	],
	"30508": [
		"default",
		"./ecom-order-listing-page",
		59888
	],
	"31543": [
		"default",
		"./finance-page",
		86285
	],
	"32325": [
		"default",
		"./supplier-warehouse-listing-page",
		13445
	],
	"32637": [
		"default",
		"./en/translation",
		13445
	],
	"33404": [
		"default",
		"./batch-price-update-page",
		13445
	],
	"33981": [
		"default",
		"./ms/translation",
		13445
	],
	"34228": [
		"default",
		"./category-preview-page",
		86285
	],
	"35960": [
		"default",
		"./chat-listing-page",
		59888
	],
	"37674": [
		"default",
		"./hcp-create-order-page",
		59888
	],
	"38234": [
		"default",
		"./supplier-inventory-view-page",
		13445
	],
	"40273": [
		"default",
		"./customer-view-page",
		43313
	],
	"44341": [
		"default",
		"./voucher-listing-page",
		86285
	],
	"45752": [
		"default",
		"./ms/translation",
		43313
	],
	"47471": [
		"default",
		"./change-password-page",
		43313
	],
	"48641": [
		"default",
		"./distributor-listing-page",
		86285
	],
	"49661": [
		"default",
		"./inventory-import-page",
		13445
	],
	"50778": [
		"default",
		"./voucher-create-page",
		86285
	],
	"51420": [
		"default",
		"./category-listing-page",
		86285
	],
	"51932": [
		"default",
		"./supplier-inventory-add-stock-page",
		13445
	],
	"53966": [
		"default",
		"./supplier-inventory-listing-page",
		13445
	],
	"54930": [
		"default",
		"./en/translation",
		22084
	],
	"57788": [
		"default",
		"./cash-manager-page",
		22084
	],
	"58338": [
		"default",
		"./internal-quotation-view",
		59888
	],
	"58382": [
		"default",
		"./hcp-return-view-page",
		59888
	],
	"60245": [
		"default",
		"./ms/translation",
		49342
	],
	"61967": [
		"default",
		"./finance-list-page",
		59888
	],
	"62290": [
		"default",
		"./recoil",
		86143
	],
	"62311": [
		"default",
		"./supplier-view-page",
		90706
	],
	"63973": [
		"default",
		"./en/translation",
		59888
	],
	"67097": [
		"default",
		"./supplier-inventory-create-page",
		13445
	],
	"68024": [
		"default",
		"./ms/translation",
		68741
	],
	"68527": [
		"default",
		"./quotation-edit",
		59888
	],
	"70745": [
		"default",
		"./brand-listing-page",
		86285
	],
	"73742": [
		"default",
		"./hcp-order-listing-page",
		59888
	],
	"78016": [
		"default",
		"./en/translation",
		49342
	],
	"82352": [
		"default",
		"./moh-order-view-page",
		59888
	],
	"82929": [
		"default",
		"./uom-listing-page",
		86285
	],
	"85379": [
		"default",
		"./moh-order-listing-page",
		59888
	],
	"87217": [
		"default",
		"./supplier-stock-movement-listing-page",
		13445
	],
	"88418": [
		"default",
		"./customer-update-page",
		43313
	],
	"88546": [
		"default",
		"./dashboard-page",
		22084
	],
	"90548": [
		"default",
		"./supplier-warehouse-update-page",
		13445
	],
	"91567": [
		"default",
		"./invoices-order-page",
		22084
	],
	"93523": [
		"default",
		"./supplier-warehouse-create-page",
		13445
	],
	"97704": [
		"default",
		"./quotation-request-listing",
		59888
	],
	"98047": [
		"default",
		"./login-page",
		22084
	],
	"98783": [
		"default",
		"./en/translation",
		86143
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}